import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class DirectorUserType {
  public readonly key = 'DirectorUserType';
  public readonly enrollTrackRole = EnrollTrackRole.Director;
}
